import { ME_EMPLOYEE_TYPES_API } from '../quote-form';

export const QUOTE_REQUEST_START = 'QUOTE_REQUEST_START';
export const QUOTE_REQUEST_SUCCESS = 'QUOTE_REQUEST_SUCCESS';
export const QUOTE_REQUEST_FAILED = 'QUOTE_REQUEST_FAILED';
export const QUOTE_INDIVIDUAL_REQUEST_START = 'QUOTE_INDIVIDUAL_REQUEST_START';
export const CALCULATE_INDIVIDUAL_REQUEST_START = 'CALCULATE_INDIVIDUAL_REQUEST_START';
export const QUOTE_INDIVIDUAL_REQUEST_SUCCESS = 'QUOTE_INDIVIDUAL_REQUEST_SUCCESS';
export const QUOTE_INDIVIDUAL_REQUEST_FAILED = 'QUOTE_INDIVIDUAL_REQUEST_FAILED';
export const COVERME_CLEAR_QUOTEDATA = 'COVERME_CLEAR_QUOTEDATA';

export type TravellerType = 'COMPANION' | 'FAMILY' | 'GROUP' | 'SINGLE' | 'STAFF' | 'STUDENT';
export type TripType = 'SINGLE' | 'MULTIPLE';

export interface Questionnaire {
  type: string;
  answers: {
    key: string;
    answer: string;
  }[];
}

export interface ProductRequest {
  code: string;
  premiumTotal?: number;
  taxTotal?: number;
  premium?: number;
  adjustments?: {
    type: string;
    value: number;
    amount?: number;
    breakdownType?: string;
  }[];
}

export interface PlanRequest extends ProductRequest {
  baseTaxTotal?: number;
  basePremium?: number;
  basePremiumTotal?: number;
  tripPreference: TripPreference;
  optionalBenefits?: ProductRequest[];
  adminfee?: number;
  HSTAmount?: number;
  branchfee?: number;
  eligibilityConsent?: boolean;
}

export interface Address {
  addressLine1: string;
  addressLine2: string;
  city: string;
  province: string;
  country: string;
  postalCode: string;
}

export interface Contact {
  email: string;
  phone: string;
  address: Address;
}

export interface TripPreference {
  tripCost: number;
  daysPerTrip?: number;
  coverageAmount?: number;
  deductible?: number;
}

export interface Dependent {
  referenceNumber: string;
  firstName?: string;
  lastName?: string;
  age?: number;
  dateOfBirth?: string;
  contact?: Contact;
  tripCost?: number;
  relationship?: string;
}

export interface Pax {
  referenceNumber: string;
  age?: number;
  dateOfBirth?: string;
  contact?: Contact;
  questionnaires?: Questionnaire[];
  plans?: PlanRequest[];
  tripBookingDate?: string;
}

export interface TripInformation {
  startDate: string;
  endDate: string;
  tripType: TripType;
  provinceOfResidence: string;
  countryOfResidence: string;
  travellingWithinCanada: boolean;
  existingCoverageDays?: number;
  tripStartDate?: string;
  departureLocation?: string;
  furthestDestination?: any;
  destinationLocations?: string[];
  isSuperVisa?: boolean;
  educationStartDate?: string;
  educationEndDate?: string;
  leavingDate?: string;
  effectiveDate?: string;
  manulifeEmployeeName?: string;
  manulifeEmployeeRelationship?: ME_EMPLOYEE_TYPES_API;
  destinationCountry?: string;
  destinationName?: string;
  hasUSLayover?: boolean;
}

export interface QuoteRequestPayload {
  language: string;
  manulifeEmployeeRelationship?: ME_EMPLOYEE_TYPES_API;
  hasCompanionDiscount?: boolean;
  travellerType: TravellerType;
  travellerCategory?: string;
  applicationDate: string;
  createdAt?: string;
  tripInformation: TripInformation;
  paxes: Pax[];
  dependents: Dependent[];
}

export interface Adjustment {
  amount: number;
  breakdownType: string;
}

export interface PaxPlan {
  code: string;
  basePremium: number;
  baseTaxTotal: number;
  basePremiumTotal: number;
  adjustments: Adjustment[];
  adjustmentTotal: number;
  premiumFactor: number;
  optionalBenefits: {
    code: string;
    premium: number;
    premiumTotal: number;
    taxTotal: number;
    premiumFactor: number;
    adjustments: Adjustment[];
  }[];
  paxOptionalBenefits?: {
    dependents: {}[];
    primary: {}[];
  };
}

export interface PaxQuote {
  referenceNumber: number;
  plans: PaxPlan[];
}

export interface QuoteResponse {
  tripType?: TripType;
  travellerType?: TravellerType;
  applicationDate?: Date;
  dependents?: {
    referenceNumber: string;
  }[];
  paxes?: PaxQuote[];
}

export interface QuoteStoreResponse {
  quoteData?: QuoteResponse;
  error?: unknown;
  loading?: boolean;
  referenceNumber?: number;
  calculate?: boolean;
}

export interface QuoteStore {
  [props: number]: QuoteStoreResponse;
  quoteFetched?: boolean;
  quoteError?: boolean;
  quoteServerError?: boolean;
}

export interface Discounts {
  manulifeEmployeeRelationship: string;
  hasCompanionDiscount: boolean;
}
